<template>
	<div>
		<div v-if="isOnline">
			<header-container />

			<router-view></router-view>

			<help-container v-once />

			<footer-container v-once />

			<loading-spinner v-once />

			<login-modal />

			<div class="overlay"></div>

			<cookie-law theme="base" storage-name="ius_cookie_law" :button-text="$t('Misc.Ok')" :button-decline="false">
				<div slot="message" v-html="$t('Sentence.CookieLawText')" />
			</cookie-law>

			<privacy-modal />
			<request-part-modal />
			<request-types-modal />
			<success-fee-modal />
			<terms-and-conditions-modal />

			<notifications group="toast" classes="toast" position="bottom right" />
		</div>
		<page-offline v-else />
	</div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
import FooterContainer from '@/components/footer/FooterContainer'
import HeaderContainer from '@/components/header/HeaderContainer'
import HelpContainer from '@/components/sections/HelpContainer'
import LoadingSpinner from '@/utils/commons/LoadingSpinner'
import LoginModal from '@/utils/modals/login/LoginModal'
import PageOffline from '@/views/PageOffline'
import PrivacyModal from '@/utils/modals/misc/PrivacyModal'
import RequestPartModal from '@/utils/modals/misc/RequestPartModal'
import RequestTypesModal from '@/utils/modals/misc/RequestTypesModal'
import SuccessFeeModal from '@/utils/modals/misc/SuccessFeeModal'
import TermsAndConditionsModal from '@/utils/modals/misc/TermsAndConditionsModal'

export default {
	components: {
		CookieLaw,
		FooterContainer,
		HeaderContainer,
		HelpContainer,
		LoadingSpinner,
		LoginModal,
		PageOffline,
		PrivacyModal,
		RequestPartModal,
		RequestTypesModal,
		SuccessFeeModal,
		TermsAndConditionsModal,
	},
	data() {
		return {
			notificationSyncTimer: null,
		}
	},
	computed: {
		isOnline() {
			return this.$store.getters.isOnline
		},
	},
	created() {
		// Subscribe to data store changes for managing notifications, this handler will be called
		// whenever a mutation is committed
		this.manageNotifications = this.$store.subscribe((mutation, state) => {
			// Manage "setUnreadNotificationsWithToast" mutation that means notifications (maybe new) exists
			if (mutation.type === 'setUnreadNotificationsWithToast') {
				// If account has unread notifications
				if (state.data.unreadNotifications) {
					// Loop over unread notifications
					state.data.unreadNotifications.forEach((notification) => {
						// Notify recent (if recent field is true)
						if (notification.recent) {
							this.showToastInfo(notification.title, notification.text, false, false)
						}
					})
				}
			}
		})
	},
	beforeUpdate() {
		// Retrieve requests (only if account is logged)
		if (this.$store.getters.loggedIn && this.$route.params.action !== 'logout') {
			this.$store.dispatch('retrieveRequests')
		}
	},
	beforeDestroy() {
		// Remove notification sync timer
		clearInterval(this.notificationSyncTimer)

		// Remove data store subscription
		this.manageNotifications()
	},
	mounted() {
		// Retrieve initial unread notifications value
		if (this.$store.getters.loggedIn) {
			// Load unread notifications (without trigger toast)
			this.$store.dispatch('retrieveUnreadNotifications', { toast: false })
		}

		this.notificationSyncTimer = setInterval(() => {
			if (this.$store.getters.loggedIn) {
				// Load unread notifications (with trigger toast)
				this.$store.dispatch('retrieveUnreadNotifications', { toast: true })
			}
		}, 30000)

		// Listen for open help event
		this.$root.$on('open-help-modal', (data) => {
			// Block scroll on modal parent
			document.querySelector('body').classList.add('overflow-hidden')

			// Emit open event
			this.$root.$emit('open-' + data.name + '-modal', data.value)
		})
	},
	destroyed() {
		// This prevents from having memory leaks
		this.$root.$off('open-help-modal')
	},
}
</script>

<style src="./assets/sass/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue